//

import axios from "axios";
import { Get, Post } from "../server";

// 公告列表
export const getNoticList = (params: any) => {
  return Get("/admin/announcement/announcements", params);
};

// 新增公告列表
export function postNoticList(data: any) {
  return axios({
    url: `/admin/announcement/announcement`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    data,
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}

// 修改公告列表
export function putNoticList({ announcementId, data }: any) {
  return axios({
    url: `/admin/announcement/announcement/${announcementId}`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    data,
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}


export const uploadNoticPicture = (data: any) => {
  return axios({
    url: `/admin/announcement/picture/upload`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    data,
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}
export const addBanner = (data: any) => {
  return axios({
    url: `/admin/adList`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    data,
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}

export const editBanner = (adId: any, data: any) => {
  return axios({
    url: `/admin/adList/${adId}`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    data,
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}

export const deleBanner = (adId: any) => {
  return axios({
    url: `/admin/adList/${adId}`,
    method: "delete",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}

export const getBanner = (params: any) => {
  return Get('/admin/adLists', params)
}